var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.741,13.972V2.694s-11.278,0-11.278,0l3.508,3.508-3.935,3.935c-1.188,1.188-1.885,2.78-1.951,4.459h0c-.161,4.076,3.336,7.343,7.392,6.905l3.807-.411-3.121-1.716c-2.394-1.316-2.855-4.561-.924-6.493l2.705-2.705,3.796,3.796Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcut);
export default __webpack_public_path__ + "static/media/shortcut.227b9d1e85e2846d16679caa10ad8bb6.svg";
export { ForwardRef as ReactComponent };